import React from 'react';
import Component from '@vfuk/core-select-input-with-menu-with-label';
const SelectInputWithMenuWithLabel = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default SelectInputWithMenuWithLabel;
